<template>
  <v-dialog v-model="navigation.insertContactDialogIsVisible" width="auto" :persistent="true">
    <v-card width="1600" style="padding: 30px;">
      <div v-if="loader.contact" style="text-align: center;">
        <v-progress-circular color="info" indeterminate></v-progress-circular>
      </div>
      <div v-else>
        <div style="display: flex;">
          <div style="width: 58.5%; margin-right: 1.5%;">
            <v-card style="padding: 20px 20px 0px 20px;" elevation="2">
              <h3>Información principal:</h3>
              <br>
              <div style="display: flex;">
                <v-select v-model="input.contactAgentID" :items="display.agentOptions" :loading="loader.selectAgentFromContactDialog" :disabled="loader.selectAgentFromContactDialog" append-inner-icon="mdi-briefcase-account" item-title="agentName" item-value="agentID" label="Agente encargado del contacto" variant="solo-filled" style="width: 40%;"></v-select>
                <v-switch v-model="input.contactIsActive" color="success" label="El contacto está activo" hide-details style="margin-left: 3%; margin-bottom: 10px;"></v-switch>
              </div>
              <v-select v-model="input.contactType" :items="display.contactTypeOptions" append-inner-icon="mdi-cog" label="Tipo de contacto" variant="solo-filled"></v-select>
              <v-select v-model="input.contactSSNType" :items="display.contactSSNTypeOptions" append-inner-icon="mdi-grid" label="Tipo de documento de identidad del contacto" variant="solo-filled"></v-select>
              <v-text-field v-model="input.contactSSN" append-inner-icon="mdi-card-account-details" label="Documento de identidad del contacto" variant="solo-filled"></v-text-field>
              <v-text-field v-model="input.contactName" append-inner-icon="mdi-account-edit" label="Nombre del contacto" variant="solo-filled"></v-text-field>  
            </v-card>  
            <br>
            <v-card style="padding: 20px 20px 0px 20px;" elevation="2">
              <h3>Información adicional:</h3>
              <br>
              <v-text-field v-model="input.contactCommercialName" append-inner-icon="mdi-store" label="Nombre comercial del contacto (opcional)" variant="solo-filled"></v-text-field>
              <v-text-field v-model="input.contactPhoneNumber" append-inner-icon="mdi-phone" label="Número de teléfono del contacto (opcional)" variant="solo-filled"></v-text-field>
              <v-text-field v-model="input.contactEmail" append-inner-icon="mdi-email" label="Correo del contacto (opcional)" variant="solo-filled"></v-text-field>
              <v-text-field v-model="input.contactWebPage" append-inner-icon="mdi-web" label="Página web del contacto (opcional)" variant="solo-filled"></v-text-field>  
              <v-textarea v-model="input.contactNote" append-inner-icon="mdi-text-box-outline" label="Nota del contacto (opcional)" variant="solo-filled"></v-textarea>  
            </v-card>  
            <div v-if="accessCredential['/contacts/contactDialog/contactCredit']">
              <br>
              <v-card style="padding: 20px 20px 0px 20px;" elevation="2">
                <div style="display: flex;">
                  <h3>Información de crédito:</h3>
                  <v-switch @update:model-value="updateContactHasCredit()" v-model="input.contactHasCredit" color="warning" label="Habilitar crédito" hide-details style="position: relative; top: -15px; left: 20px;"></v-switch>
                </div>
                <div v-if="input.contactHasCredit" style="display: flex;">
                  <div style="width: 49%; margin-right: 1%;">
                    <v-text-field v-model="input.contactCreditAmount" append-inner-icon="mdi-cash" label="Límite de crédito del contacto" type="text" hide-spin-buttons variant="solo-filled"></v-text-field>
                  </div>
                  <div style="width: 49%; margin-left: 1%;">
                    <v-number-input :min="0" :max="90" v-model="input.contactCreditDay" control-variant="split"></v-number-input>
                  </div>
                </div>
              </v-card>
            </div>
          </div>
          <div style="width: 40%;">
            <v-card style="padding: 20px 20px 0px 20px;" elevation="2">
              <h3>Imagen del perfil:</h3>
              <br>
              <input @change="processImage('contactImage')" type="file" accept="image/*" ref="contactImage" id="contactImage" style="display: none;">  
              <img v-if="input.contactImage == null" @click="uploadImage('contactImage')" :src="assets.userPlaceholderImage" style="cursor: pointer; width: 42%;">
              <img v-else @click="uploadImage()" :src="input.contactImage" style="cursor: pointer; width: 42%;">
              <br><br>
            </v-card>
            <br>
            <v-card style="padding: 20px 20px 0px 20px;" elevation="2">
              <h3>Imagen del documento de identidad:</h3>
              <br>
              <input @change="processImage('contactSSNImage')" type="file" accept="image/*" ref="contactSSNImage" id="contactSSNImage" style="display: none;">  
              <img v-if="input.contactSSNImage == null" @click="uploadImage('contactSSNImage')" :src="assets.userPlaceholderImage" style="cursor: pointer; width: 42%;">
              <img v-else @click="uploadImage()" :src="input.contactSSNImage" style="cursor: pointer; width: 42%;">
              <br><br>
            </v-card>
            <br>
            <v-card style="padding: 20px 20px 0px 20px;" elevation="2">
              <h3>Ubicación:</h3>
              <br>
              <v-autocomplete @update:model-value="updateContactCountry()" v-model="input.contactCountry" :items="display.contactCountryOptions" append-inner-icon="mdi-earth" label="País de residencia del contacto (opcional)" variant="solo-filled"></v-autocomplete>
              <div v-if="input.contactCountry == 'Costa Rica'">
                <v-autocomplete 
                  @update:model-value="updateContactProvince()"
                  v-model="input.contactProvince" 
                  :items="Object.keys(display.contactLocationOptions)" 
                  append-inner-icon="mdi-numeric-1-circle" 
                  label="Provincia de residencia del contacto (opcional)" 
                  variant="solo-filled">
                </v-autocomplete>
                <v-autocomplete 
                  @update:model-value="updateContactCanton()"
                  v-model="input.contactCanton" 
                  :items="this.display.contactLocationOptions[this.input.contactProvince] ? Object.keys(this.display.contactLocationOptions[this.input.contactProvince]) : []" 
                  append-inner-icon="mdi-numeric-2-circle" 
                  label="Cantón de residencia del contacto (opcional)" 
                  variant="solo-filled">
                </v-autocomplete>
                <v-autocomplete 
                  v-model="input.contactDistrict" 
                  :items="this.display.contactLocationOptions[this.input.contactProvince] ? (this.display.contactLocationOptions[this.input.contactProvince][this.input.contactCanton] ? this.display.contactLocationOptions[this.input.contactProvince][this.input.contactCanton] : []) : []" 
                  append-inner-icon="mdi-numeric-3-circle" 
                  label="Distrito de residencia del contacto (opcional)" 
                  variant="solo-filled">
                </v-autocomplete>  
                <v-textarea v-model="input.contactLocationNote" rows="5" append-inner-icon="mdi-text-box-outline" label="Nota de residencia del contacto (opcional)" variant="solo-filled"></v-textarea>
              </div>
            </v-card>
            <br>
            <v-card style="padding: 20px 20px 0px 20px;" elevation="2">
              <h3>Información de facturación electrónica:</h3>
              <br>
              <v-select v-model="input.contactBillingSSNType" :items="display.contactSSNTypeOptions" append-inner-icon="mdi-grid" label="Tipo de documento de identidad" variant="solo-filled"></v-select>
              <v-text-field v-model="input.contactBillingSSN" append-inner-icon="mdi-card-account-details" label="Documento de identidad" variant="solo-filled"></v-text-field>
              <v-text-field v-model="input.contactBillingName" append-inner-icon="mdi-account-edit" label="Nombre del contacto" variant="solo-filled"></v-text-field>  
              <v-text-field v-model="input.contactBillingPhoneNumber" append-inner-icon="mdi-phone" label="Número de teléfono" variant="solo-filled"></v-text-field>
              <v-text-field v-model="input.contactBillingEmail" append-inner-icon="mdi-email" label="Correo electrónico" variant="solo-filled"></v-text-field>
            </v-card>
          </div>
        </div>
        <br><br><br>
        <v-btn v-if="navigation.contactID" @click="updateContact()" dark block height="38" color="success">
          <h3>EDITAR CONTACTO</h3>
          <v-icon style="margin-left: 20px;" dark right>mdi-content-save</v-icon>
        </v-btn>
        <v-btn v-else @click="insertContact()" dark block height="38" color="success">
          <h3>CREAR CONTACTO</h3>
          <v-icon style="margin-left: 20px;" dark right>mdi-plus-circle</v-icon>
        </v-btn>
        <br>
        <v-btn @click="setDefaultValues()" dark block height="38" color="error">
          <h3>CANCELAR</h3>
          <v-icon style="margin-left: 20px;" dark right>mdi-close-circle</v-icon>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<style scoped>
</style>

<script>
import { viewMethodCaller } from '../viewMethodCaller.js';

export default {
  name: "ContactDialog",
  inject: ['$generalFunctions'],

  data: () => ({

    input:
    {
      contactAgentID: null,
      contactType: null,
      contactSSNType: null,
      contactSSN: null,
      contactName: null,
      contactCommercialName: null,
      contactPhoneNumber: null,
      contactEmail: null,
      contactWebPage: null,
      contactImage: null,
      contactSSNImage: null,
      contactCountry: 'Costa Rica',
      contactProvince: null,
      contactCanton: null,
      contactDistrict: null,
      contactLocationNote: null,
      contactHasCredit: false,
      contactCreditAmount: null,
      contactCreditDay: 0,
      contactNote: null,

      contactBillingSSNType: null,
      contactBillingSSN: null,
      contactBillingName: null,
      contactBillingPhoneNumber: null,
      contactBillingEmail: null,

      contactIsActive: true
    },

    display: 
    {
      agentOptions: [],
      contactTypeOptions: ['Persona', 'Empresa', 'Otro'],
      contactSSNTypeOptions: ['Física', 'Jurídica', 'DIMEX', 'Otro'],
      contactCountryOptions: ["Afganistán", "Albania", "Argelia", "Andorra", "Angola", "Antigua y Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaiyán", "Bahamas", "Baréin", "Bangladés", "Barbados", "Bielorrusia", "Bélgica", "Belice", "Benín", "Bután", "Bolivia", "Bosnia y Herzegovina", "Botsuana", "Brasil", "Brunéi", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Camboya", "Camerún", "Canadá", "República Centroafricana", "Chad", "Chile", "China", "Colombia", "Comoras", "Congo (República del Congo)", "Costa Rica", "Croacia", "Cuba", "Chipre", "Chequia (República Checa)", "República Democrática del Congo", "Dinamarca", "Yibuti", "Dominica", "República Dominicana", "Ecuador", "Egipto", "El Salvador", "Guinea Ecuatorial", "Eritrea", "Estonia", "Esuatini (antes Suazilandia)", "Etiopía", "Fiyi", "Finlandia", "Francia", "Gabón", "Gambia", "Georgia", "Alemania", "Ghana", "Grecia", "Granada", "Guatemala", "Guinea", "Guinea-Bisáu", "Guyana", "Haití", "Honduras", "Hungría", "Islandia", "India", "Indonesia", "Irán", "Irak", "Irlanda", "Israel", "Italia", "Jamaica", "Japón", "Jordania", "Kazajistán", "Kenia", "Kiribati", "Kuwait", "Kirguistán", "Laos", "Letonia", "Líbano", "Lesoto", "Liberia", "Libia", "Liechtenstein", "Lituania", "Luxemburgo", "Madagascar", "Malaui", "Malasia", "Maldivas", "Malí", "Malta", "Islas Marshall", "Mauritania", "Mauricio", "México", "Micronesia", "Moldavia", "Mónaco", "Mongolia", "Montenegro", "Marruecos", "Mozambique", "Birmania (Myanmar)", "Namibia", "Nauru", "Nepal", "Países Bajos", "Nueva Zelanda", "Nicaragua", "Níger", "Nigeria", "Corea del Norte", "Macedonia del Norte", "Noruega", "Omán", "Pakistán", "Palaos", "Estado de Palestina", "Panamá", "Papúa Nueva Guinea", "Paraguay", "Perú", "Filipinas", "Polonia", "Portugal", "Catar", "Rumanía", "Rusia", "Ruanda", "San Cristóbal y Nieves", "Santa Lucía", "San Vicente y las Granadinas", "Samoa", "San Marino", "Santo Tomé y Príncipe", "Arabia Saudita", "Senegal", "Serbia", "Seychelles", "Sierra Leona", "Singapur", "Eslovaquia", "Eslovenia", "Islas Salomón", "Somalia", "Sudáfrica", "Corea del Sur", "Sudán del Sur", "España", "Sri Lanka", "Sudán", "Surinam", "Suecia", "Suiza", "Siria", "Taiwán", "Tayikistán", "Tanzania", "Tailandia", "Timor-Leste", "Togo", "Tonga", "Trinidad y Tobago", "Túnez", "Turquía", "Turkmenistán", "Tuvalu", "Uganda", "Ucrania", "Emiratos Árabes Unidos", "Reino Unido", "Estados Unidos de América", "Uruguay", "Uzbekistán", "Vanuatu", "Vaticano", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabue"],
      contactLocationOptions:
      {
        "San José": {
          "San José": ["Carmen", "Merced", "Hospital", "Catedral", "Zapote", "San Francisco de Dos Ríos", "Uruca", "Mata Redonda", "Pavas", "Hatillo", "San Sebastián"],
          "Escazú": ["Escazú", "San Antonio", "San Rafael"],
          "Desamparados": ["Desamparados", "San Miguel", "San Juan de Dios", "San Rafael Arriba", "San Rafael Abajo", "Gravilias", "Los Guido"],
          "Puriscal": ["Santiago", "Mercedes Sur", "Barbacoas", "Grifo Alto", "San Rafael", "Candelarita", "Desamparaditos", "San Antonio", "Chires"],
          "Tarrazú": ["San Marcos", "San Lorenzo", "San Carlos"],
          "Aserrí": ["Aserrí", "Tarbaca", "Vuelta de Jorco", "San Gabriel", "Legua", "Monterrey", "Salitrillos"],
          "Mora": ["Ciudad Colón", "Guayabo", "Tabarcia", "Piedras Negras", "Picagres", "Jaris", "Quitirrisí"],
          "Goicoechea": ["Guadalupe", "San Francisco", "Calle Blancos", "Mata de Plátano", "Ipís", "Rancho Redondo", "Purral"],
          "Santa Ana": ["Santa Ana", "Salitral", "Pozos", "Uruca", "Piedades", "Brasil"],
          "Alajuelita": ["Alajuelita", "San Josecito", "San Antonio", "Concepción", "San Felipe"],
          "Vázquez de Coronado": ["San Isidro", "San Rafael", "Dulce Nombre de Jesús", "Patalillo", "Cascajal"],
          "Acosta": ["San Ignacio", "Guaitil", "Palmichal", "Cangrejal", "Sabanillas"],
          "Tibás": ["San Juan", "Cinco Esquinas", "Anselmo Llorente", "León XIII", "Colima"],
          "Moravia": ["San Vicente", "San Jerónimo", "Trinidad"],
          "Montes de Oca": ["San Pedro", "Sabanilla", "Mercedes", "San Rafael"],
          "Turrubares": ["San Pablo", "San Pedro", "San Juan de Mata", "San Luis", "Carara"],
          "Dota": ["Santa María", "Jardín", "Copey"],
          "Curridabat": ["Curridabat", "Granadilla", "Sánchez", "Tirrases"],
          "Pérez Zeledón": ["San Isidro de El General", "El General", "Daniel Flores", "Rivas", "San Pedro", "Platanares", "Pejibaye", "Cajón", "Barú", "Río Nuevo", "Páramo"],
          "León Cortés": ["San Pablo", "San Andrés", "Llano Bonito", "San Isidro", "Santa Cruz", "San Antonio"]
        },
        "Alajuela": {
          "Alajuela": ["Alajuela", "San José", "Carrizal", "San Antonio", "Guácima", "San Isidro", "Sabanilla", "San Rafael", "Río Segundo", "Desamparados", "Turrúcares", "Tambor", "Garita", "Sarapiquí"],
          "San Ramón": ["San Ramón", "Santiago", "San Juan", "Piedades Norte", "Piedades Sur", "San Rafael", "San Isidro", "Angeles", "Alfaro", "Volio", "Concepción", "Zapotal", "Peñas Blancas"],
          "Grecia": ["Grecia", "San Isidro", "San José", "San Roque", "Tacares", "Río Cuarto", "Puente de Piedra", "Bolívar"],
          "San Mateo": ["San Mateo", "Desmonte", "Jesús María", "Labrador"],
          "Atenas": ["Atenas", "Jesús", "Mercedes", "San Isidro", "Concepción", "San José", "Santa Eulalia", "Escobal"],
          "Naranjo": ["Naranjo", "San Miguel", "San José", "Cirrí Sur", "San Jerónimo", "San Juan", "Rosario", "Palmitos"],
          "Palmares": ["Palmares", "Zaragoza", "Buenos Aires", "Santiago", "Candelaria", "Esquipulas", "La Granja"],
          "Poás": ["San Pedro", "San Juan", "San Rafael", "Carrillos", "Sabana Redonda"],
          "Orotina": ["Orotina", "Mastate", "Hacienda Vieja", "Coyolar", "La Ceiba"],
          "San Carlos": ["Quesada", "Florencia", "Buenavista", "Aguas Zarcas", "Venecia", "Pital", "La Fortuna", "La Tigra", "La Palmera", "Venado", "Cutris", "Monterrey", "Pocosol"],
          "Zarcero": ["Zarcero", "Laguna", "Tapesco", "Guadalupe", "Palmira", "Zapote", "Brisas"],
          "Sarchí": ["Sarchí Norte", "Sarchí Sur", "Toro Amarillo", "San Pedro", "Rodríguez"],
          "Upala": ["Upala", "Aguas Claras", "San José (Pizote)", "Bijagua", "Delicias", "Dos Ríos", "Yolillal", "Canalete"],
          "Los Chiles": ["Los Chiles", "Caño Negro", "El Amparo", "San Jorge"],
          "Guatuso": ["San Rafael", "Buenavista", "Cote", "Katira"],
          "Río Cuarto": ["Río Cuarto", "Santa Isabel", "Santa Rita"]
        },
        "Cartago": {
          "Cartago": ["Oriental", "Occidental", "Carmen", "San Nicolás", "Aguacaliente", "Guadalupe", "Corralillo", "Tierra Blanca", "Dulce Nombre", "Llano Grande", "Quebradilla"],
          "Paraíso": ["Paraíso", "Santiago", "Orosi", "Cachí", "Llanos de Santa Lucía"],
          "La Unión": ["Tres Ríos", "San Diego", "San Juan", "San Rafael", "Concepción", "Dulce Nombre", "San Ramón", "Río Azul"],
          "Jiménez": ["Juan Viñas", "Tucurrique", "Pejibaye"],
          "Turrialba": ["Turrialba", "La Suiza", "Peralta", "Santa Cruz", "Santa Teresita", "Pavones", "Tuis", "Tayutic", "Santa Rosa", "Tres Equis", "La Isabel", "Chirripó"],
          "Alvarado": ["Pacayas", "Cervantes", "Capellades"],
          "Oreamuno": ["San Rafael", "Cot", "Potrero Cerrado", "Cipreses", "Santa Rosa"],
          "El Guarco": ["El Tejar", "San Isidro", "Tobosi", "Patio de Agua"]
        },
        "Heredia": {
          "Heredia": ["Heredia", "Mercedes", "San Francisco", "Ulloa", "Vara Blanca"],
          "Barva": ["Barva", "San Pedro", "San Pablo", "San Roque", "Santa Lucía", "San José de la Montaña"],
          "Santo Domingo": ["Santo Domingo", "San Vicente", "San Miguel", "Paracito", "Santo Tomás", "Santa Rosa", "Tures", "Pará"],
          "Santa Bárbara": ["Santa Bárbara", "San Pedro", "San Juan", "Jesús", "Santo Domingo", "Puraba"],
          "San Rafael": ["San Rafael", "San Josecito", "Santiago", "Angeles", "Concepción"],
          "San Isidro": ["San Isidro", "San José", "Concepción", "San Francisco"],
          "Belén": ["San Antonio", "La Ribera", "La Asunción"],
          "Flores": ["San Joaquín", "Barrantes", "Llorente"],
          "San Pablo": ["San Pablo", "Rincón de Sabanilla"],
          "Sarapiquí": ["Puerto Viejo", "La Virgen", "Horquetas", "Llanuras del Gaspar", "Cureña"]
        },
        "Guanacaste": {
          "Liberia": ["Liberia", "Cañas Dulces", "Mayorga", "Nacascolo", "Curubandé"],
          "Nicoya": ["Nicoya", "Mansión", "San Antonio", "Quebrada Honda", "Sámara", "Nosara", "Belén de Nosarita"],
          "Santa Cruz": ["Santa Cruz", "Bolsón", "Veintisiete de Abril", "Tempate", "Cartagena", "Cuajiniquil", "Diriá", "Cabo Velas", "Tamarindo"],
          "Bagaces": ["Bagaces", "La Fortuna", "Mogote", "Río Naranjo"],
          "Carrillo": ["Filadelfia", "Palmira", "Sardinal", "Belén"],
          "Cañas": ["Cañas", "Palmira", "San Miguel", "Bebedero", "Porozal"],
          "Abangares": ["Las Juntas", "Sierra", "San Juan", "Colorado"],
          "Tilarán": ["Tilarán", "Quebrada Grande", "Tronadora", "Santa Rosa", "Líbano", "Tierras Morenas", "Arenal"],
          "Nandayure": ["Carmona", "Santa Rita", "Zapotal", "San Pablo", "Porvenir", "Bejuco"],
          "La Cruz": ["La Cruz", "Santa Cecilia", "La Garita", "Santa Elena"],
          "Hojancha": ["Hojancha", "Monte Romo", "Puerto Carrillo", "Huacas", "Matambú"]
        },
        "Puntarenas": {
          "Puntarenas": ["Puntarenas", "Pitahaya", "Chomes", "Lepanto", "Paquera", "Manzanillo", "Guacimal", "Barranca", "Monteverde", "Isla del Coco", "Cóbano", "Chacarita", "Chira", "Acapulco", "El Roble", "Arancibia"],
          "Esparza": ["Esparza", "San Jerónimo", "Caldera", "Macacona", "San Rafael", "San Juan Grande", "Tarcoles"],
          "Buenos Aires": ["Buenos Aires", "Volcán", "Potrero Grande", "Boruca", "Pilas", "Colinas", "Chánguena", "Biolley", "Brunka"],
          "Montes de Oro": ["Miramar", "La Unión", "San Isidro"],
          "Osa": ["Puerto Cortés", "Palmar", "Sierpe", "Bahía Ballena", "Piedras Blancas", "Bahía Drake"],
          "Quepos": ["Quepos", "Savegre", "Naranjito"],
          "Golfito": ["Golfito", "Puerto Jiménez", "Guaycará", "Pavón"],
          "Coto Brus": ["San Vito", "Sabalito", "Aguabuena", "Limoncito", "Pittier", "Gutiérrez Braun"],
          "Parrita": ["Parrita"],
          "Corredores": ["Corredor", "La Cuesta", "Canoas", "Laurel"],
          "Garabito": ["Jacó", "Tárcoles"]
        },
        "Limón": {
          "Limón": ["Limón", "Valle La Estrella", "Río Blanco", "Matama"],
          "Pococí": ["Guápiles", "Jiménez", "La Rita", "Roxana", "Cariari", "Colorado"],
          "Siquirres": ["Siquirres", "Pacuarito", "Florida", "Germania", "Cairo", "Alegría"],
          "Talamanca": ["Bratsi", "Sixaola", "Cahuita", "Telire"],
          "Matina": ["Matina", "Batán", "Carrandi"],
          "Guácimo": ["Guácimo", "Mercedes", "Pocora", "Río Jiménez", "Duacarí"]
        }
      }
    },

    navigation: 
    {
      insertContactDialogIsVisible: false,
      contactID: null
    },

    loader:
    {
      selectAgentFromContactDialog: false,
      insertContact: false
    },

    assets:
    {
      userPlaceholderImage: null
    },

    localStorage: 
    {
      agentID: null
    },

    accessCredential: {}

  }),

  watch: {

  },

  methods: {
    validateInput(){
      const regularExpressionChecker = /\S/;
      const positiveNumberChecker = /^(?:0|[1-9]\d*)(?:\.\d+)?$/;
      if (this.input.contactAgentID == null){
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'INFORMACIÓN INCOMPLETA',
          'notificationDialogBody': 'Seleccione un agente encargado del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'warning',
          'notificationDialogIsPersistent': false
        });
        return false;
      }
      if (this.input.contactType == null){
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'INFORMACIÓN INCOMPLETA',
          'notificationDialogBody': 'Seleccione un tipo de contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'warning',
          'notificationDialogIsPersistent': false
        });
        return false;
      }
      if (this.input.contactSSNType == null){
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'INFORMACIÓN DEMASIADO LARGA',
          'notificationDialogBody': 'Seleccione un tipo de documento de identidad del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'warning',
          'notificationDialogIsPersistent': false
        });
        return false;
      }
      if ((this.input.contactSSN == null) || (regularExpressionChecker.test(this.input.contactSSN) == false)){
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'INFORMACIÓN DEMASIADO LARGA',
          'notificationDialogBody': 'Coloque un documento de identidad del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'warning',
          'notificationDialogIsPersistent': false
        });
        return false;
      }
      if (this.input.contactSSN.length > 30){
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'INFORMACIÓN DEMASIADO LARGA',
          'notificationDialogBody': 'El documento de identidad del contacto no puede exceder los 30 caracteres, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'warning',
          'notificationDialogIsPersistent': false
        });
        return false;
      }
      if ((this.input.contactName == null) || (regularExpressionChecker.test(this.input.contactName) == false)){
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'INFORMACIÓN INCOMPLETA',
          'notificationDialogBody': 'Coloque un nombre del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'warning',
          'notificationDialogIsPersistent': false
        });
        return false;
      }
      if ((this.input.contactCommercialName != null) && (this.input.contactCommercialName.length > 255)){
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'INFORMACIÓN DEMASIADO LARGA',
          'notificationDialogBody': 'El nombre comercial del contacto no puede exceder los 255 caracteres, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'warning',
          'notificationDialogIsPersistent': false
        });
        return false;
      }
      if ((this.input.contactPhoneNumber != null) && (this.input.contactPhoneNumber.length > 30)){
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'INFORMACIÓN DEMASIADO LARGA',
          'notificationDialogBody': 'El número de teléfono del contacto no puede exceder los 30 caracteres, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'warning',
          'notificationDialogIsPersistent': false
        });
        return false;
      }
      if ((this.input.contactEmail != null) && (this.input.contactEmail.length > 255)){
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'INFORMACIÓN DEMASIADO LARGA',
          'notificationDialogBody': 'El correo electrónico del contacto no puede exceder los 255 caracteres, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'warning',
          'notificationDialogIsPersistent': false
        });
        return false;
      }
      if ((this.input.contactWebPage != null) && (this.input.contactWebPage.length > 100)){
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'INFORMACIÓN DEMASIADO LARGA',
          'notificationDialogBody': 'La página web del contacto no puede exceder los 100 caracteres, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'warning',
          'notificationDialogIsPersistent': false
        });
        return false;
      }
      if ((this.input.contactLocationNote != null) && (this.input.contactLocationNote.length > 65000)){
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'INFORMACIÓN DEMASIADO LARGA',
          'notificationDialogBody': 'La nota de residencia del contacto no puede exceder los 65000 caracteres, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'warning',
          'notificationDialogIsPersistent': false
        });
        return false;
      }
      if ((this.input.contactCreditAmount != null) && (positiveNumberChecker.test(this.input.contactCreditAmount) == false)){
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'INFORMACIÓN INCORRECTA',
          'notificationDialogBody': 'El límite de crédito del contacto debe ser un número entero positivo, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'warning',
          'notificationDialogIsPersistent': false
        });
        return false;
      }
      if ((this.input.contactHasCredit) && ((this.input.contactCreditDay > 90) || (positiveNumberChecker.test(this.input.contactCreditAmount) == false)) ){
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'INFORMACIÓN INCORRECTA',
          'notificationDialogBody': 'La cantidad de días de crédito del contacto debe ser un número entero positivo menor que 90, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'warning',
          'notificationDialogIsPersistent': false
        });
        return false;
      }
      return true;
    },

    async insertContact(){
      this.loader.contact = true;
      if (this.validateInput()){
        const contactBillingInformation = JSON.stringify(
          { 
            'contactSSNType': this.input.contactBillingSSNType,
            'contactSSN': this.input.contactBillingSSN,
            'contactName': this.input.contactBillingName,
            'contactPhoneNumber': this.input.contactBillingPhoneNumber,
            'contactEmail': this.input.contactBillingEmail
          }
        );
        const insertContactRequestQuery = 
        {
          'contactAgentID': this.input.contactAgentID,
          'contactType': this.input.contactType,
          'contactSSNType': this.input.contactSSNType,
          'contactSSN': this.input.contactSSN,
          'contactName': this.input.contactName,
          'contactCommercialName': this.input.contactCommercialName,
          'contactPhoneNumber': this.input.contactPhoneNumber,
          'contactEmail': this.input.contactEmail,
          'contactWebPage': this.input.contactWebPage,
          'contactCountry': this.input.contactCountry,
          'contactProvince': this.input.contactProvince,
          'contactCanton': this.input.contactCanton,
          'contactDistrict': this.input.contactDistrict,
          'contactLocationNote': this.input.contactLocationNote,
          'contactImage': this.input.contactImage,
          'contactSSNImage': this.input.contactSSNImage,
          'contactCreditAmount': this.input.contactCreditAmount,
          'contactCreditDay': this.input.contactCreditDay,
          'contactNote': this.input.contactNote,
          'contactBillingInformation': contactBillingInformation,
          'contactIsActive': this.input.contactIsActive
        };
        const insertContactResult = await this.$generalFunctions.default.methods.executeHttpPostRequest('/contact/functions/insert', insertContactRequestQuery);
        if (insertContactResult.success){
          this.$root.notificationDialog.showNotificationDialog({
            'notificationDialogTitle': 'ÉXITO',
            'notificationDialogBody': 'Contacto creado exitosamente',
            'notificationDialogColor': 'success',
            'notificationDialogIsPersistent': false
          });
          viewMethodCaller.emit('ContactsView/methods/selectContactFromContactsView()');
          await this.setDefaultValues();
        } else {
          this.$root.notificationDialog.showNotificationDialog({
            'notificationDialogTitle': 'ERROR',
            'notificationDialogBody': 'Ha ocurrido un error inesperado al crear el contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
            'notificationDialogColor': 'error',
            'notificationDialogIsPersistent': false
          });
        }
      }
      this.loader.contact = false;
    },

    async updateContact(){
      this.loader.contact = true;
      if (this.validateInput()){
        const contactBillingInformation = JSON.stringify(
          { 
            'contactSSNType': this.input.contactBillingSSNType,
            'contactSSN': this.input.contactBillingSSN,
            'contactName': this.input.contactBillingName,
            'contactPhoneNumber': this.input.contactBillingPhoneNumber,
            'contactEmail': this.input.contactBillingEmail
          }
        );
        const updateContactRequestQuery = 
        {
          'contactID': this.navigation.contactID,
          'contactAgentID': this.input.contactAgentID,
          'contactType': this.input.contactType,
          'contactSSNType': this.input.contactSSNType,
          'contactSSN': this.input.contactSSN,
          'contactName': this.input.contactName,
          'contactCommercialName': this.input.contactCommercialName,
          'contactPhoneNumber': this.input.contactPhoneNumber,
          'contactEmail': this.input.contactEmail,
          'contactWebPage': this.input.contactWebPage,
          'contactCountry': this.input.contactCountry,
          'contactProvince': this.input.contactProvince,
          'contactCanton': this.input.contactCanton,
          'contactDistrict': this.input.contactDistrict,
          'contactLocationNote': this.input.contactLocationNote,
          'contactImage': this.input.contactImage,
          'contactSSNImage': this.input.contactSSNImage,
          'contactCreditAmount': this.input.contactCreditAmount,
          'contactCreditDay': this.input.contactCreditDay,
          'contactNote': this.input.contactNote,
          'contactBillingInformation': contactBillingInformation,
          'contactIsActive': this.input.contactIsActive
        };
        const updateContactResult = await this.$generalFunctions.default.methods.executeHttpPostRequest('/contact/functions/update', updateContactRequestQuery);
        if (updateContactResult.success){
          this.$root.notificationDialog.showNotificationDialog({
            'notificationDialogTitle': 'ÉXITO',
            'notificationDialogBody': 'Contacto actualizado exitosamente',
            'notificationDialogColor': 'success',
            'notificationDialogIsPersistent': false
          });
          viewMethodCaller.emit('ContactsView/methods/selectContactFromContactsView()');
          await this.setDefaultValues();
        } else {
          this.$root.notificationDialog.showNotificationDialog({
            'notificationDialogTitle': 'ERROR',
            'notificationDialogBody': 'Ha ocurrido un error inesperado al actualizar el contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
            'notificationDialogColor': 'error',
            'notificationDialogIsPersistent': false
          });
        }
      }
      this.loader.contact = false;
    },

    async selectContactFromContactDialog(){
      this.loader.contact = true;
      const selectContactFromContactDialogRequestQuery = 
      {
        'contactID': this.navigation.contactID,
      };
      const selectContactFromContactDialogResult = await this.$generalFunctions.default.methods.executeHttpPostRequest('/contact/functions/selectContactFromContactDialog', selectContactFromContactDialogRequestQuery);
      if (selectContactFromContactDialogResult.success){
        this.input.contactAgentID = selectContactFromContactDialogResult.result.contactAgentID;
        this.input.contactType = selectContactFromContactDialogResult.result.contactType;
        this.input.contactSSNType = selectContactFromContactDialogResult.result.contactSSNType;
        this.input.contactSSN = selectContactFromContactDialogResult.result.contactSSN;
        this.input.contactName = selectContactFromContactDialogResult.result.contactName;
        this.input.contactCommercialName = selectContactFromContactDialogResult.result.contactCommercialName;
        this.input.contactPhoneNumber = selectContactFromContactDialogResult.result.contactPhoneNumber;
        this.input.contactEmail = selectContactFromContactDialogResult.result.contactEmail;
        this.input.contactWebPage = selectContactFromContactDialogResult.result.contactWebPage;
        this.input.contactImage = selectContactFromContactDialogResult.result.contactImage ? `data:image/jpeg;base64,${selectContactFromContactDialogResult.result.contactImage}` : null;
        this.input.contactSSNImage = selectContactFromContactDialogResult.result.contactSSNImage ? `data:image/jpeg;base64,${selectContactFromContactDialogResult.result.contactSSNImage}` : null;
        this.input.contactCountry = selectContactFromContactDialogResult.result.contactCountry;
        this.input.contactProvince = selectContactFromContactDialogResult.result.contactProvince;
        this.input.contactCanton = selectContactFromContactDialogResult.result.contactCanton;
        this.input.contactDistrict = selectContactFromContactDialogResult.result.contactDistrict;
        this.input.contactLocationNote = selectContactFromContactDialogResult.result.contactLocationNote;
        this.input.contactHasCredit = selectContactFromContactDialogResult.result.contactCreditAmount != null;
        this.input.contactCreditAmount = selectContactFromContactDialogResult.result.contactCreditAmount;
        this.input.contactCreditDay = selectContactFromContactDialogResult.result.contactCreditDay;
        this.input.contactNote = selectContactFromContactDialogResult.result.contactNote;
        const contactBillingInformation = JSON.parse(selectContactFromContactDialogResult.result.contactBillingInformation);
        this.input.contactBillingSSNType = contactBillingInformation.contactSSNType;
        this.input.contactBillingSSN = contactBillingInformation.contactSSN;
        this.input.contactBillingName = contactBillingInformation.contactName;
        this.input.contactBillingPhoneNumber = contactBillingInformation.contactPhoneNumber;
        this.input.contactBillingEmail = contactBillingInformation.contactEmail;
        this.input.contactIsActive = selectContactFromContactDialogResult.result.contactIsActive == 1;
      } else {
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'ERROR',
          'notificationDialogBody': 'Ha ocurrido un error inesperado al consultar la información del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'error',
          'notificationDialogIsPersistent': false
        });
        await this.setDefaultValues();
      }
      this.loader.contact = false;
    },

    async selectAgentFromContactDialog(){
      this.loader.selectAgentFromContactDialog = true;
      const selectAgentFromContactDialogRequestQuery = 
      {
        'agentLocalityID': this.localStorage.localityID, 
        'agentIsActive': true,
        'accessCredentialName': '/contacts/contactDialog/contactAgentID'
      };
      const selectAgentFromContactDialogResult = await this.$generalFunctions.default.methods.executeHttpPostRequest('/agent/select/agentIDAndAgentName/byAgentLocalityIDAndByAgentIsActiveAndByAccessCredentialName', selectAgentFromContactDialogRequestQuery);
      if (selectAgentFromContactDialogResult.success){
        this.display.agentOptions = selectAgentFromContactDialogResult.result;
        this.loader.selectAgentFromContactDialog = false;
      } else {
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'ERROR',
          'notificationDialogBody': 'Ha ocurrido un error inesperado al consultar la lista de agentes encargados del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'error',
          'notificationDialogIsPersistent': false
        });
      }
    },

    uploadImage(id){
      document.getElementById(id).click();
    },

    processImage(id){
      const previousImage = this.input[id];
      try {
        this.input[id] = this.$refs[id].files[0];
        const imageFileReader = new FileReader();
        imageFileReader.readAsDataURL(this.input[id]);
        imageFileReader.onload = () => {
          this.input[id] = imageFileReader.result;
        };
        imageFileReader.onerror = function () {
          this.$root.notificationDialog.showNotificationDialog({
            'notificationDialogTitle': 'ERROR',
            'notificationDialogBody': 'Ha ocurrido un error inesperado al cargar la imagen, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
            'notificationDialogColor': 'error',
            'notificationDialogIsPersistent': false
          });
          throw new Error('Error when charging the image');
        };
      } catch {
        this.input.contactImage = previousImage;
      }
    },


    updateContactCountry(){
      this.input.contactProvince = null;
      this.input.contactCanton = null;
      this.input.contactDistrict = null;
    },

    updateContactProvince(){
      this.input.contactCanton = null;
      this.input.contactDistrict = null;
    },

    updateContactCanton(){
      this.input.contactDistrict = null;
    },

    updateContactHasCredit(){
      this.input.contactCreditAmount = null;
      this.input.contactCreditDay = 0;
    },

    async setDefaultValues() {
      this.input.contactAgentID = null;
      this.input.contactType = null;
      this.input.contactSSNType = null;
      this.input.contactSSN = null;
      this.input.contactName = null;
      this.input.contactCommercialName = null;
      this.input.contactPhoneNumber = null;
      this.input.contactEmail = null;
      this.input.contactWebPage = null;
      this.input.contactImage = null;
      this.input.contactCountry = 'Costa Rica';
      this.input.contactProvince = null;
      this.input.contactCanton = null;
      this.input.contactDistrict = null;
      this.input.contactLocationNote = null;
      this.input.contactHasCredit = false;
      this.input.contactCreditAmount = null;
      this.input.contactCreditDay = 0;
      this.input.contactNote = null;
      this.input.contactBillingSSNType = null;
      this.input.contactBillingSSN = null;
      this.input.contactBillingName = null;
      this.input.contactBillingPhoneNumber = null;
      this.input.contactBillingEmail = null;
      this.input.contactIsActive = true;
      this.navigation.insertContactDialogIsVisible = false;
      this.navigation.contactID = null;
      this.loader.selectAgentFromContactDialog = false;
      this.loader.contact = false;
    },

    async getLocalStorageData(){
      this.assets.userPlaceholderImage = this.$generalFunctions.default.data.userPlaceholderImage;
      this.localStorage.agentID = localStorage.getItem('agentID');
      this.accessCredential = await this.$generalFunctions.default.methods.validateCredentialAccess(this.localStorage.agentID);
    },

    async openContactDialog(contactID) {
      await this.setDefaultValues();
      await this.getLocalStorageData();
      await this.selectAgentFromContactDialog();
      this.navigation.contactID = contactID;
      if (this.navigation.contactID){
        await this.selectContactFromContactDialog();
      }
      this.navigation.insertContactDialogIsVisible = true;
    }
  },

  mounted(){
  }
}
</script>